type Props = { size?: number; className?: string; src?: string }

// The Social Brew logo cup with a transparent background (public/logo-cup.png),
// so it can sit on any background. Small reusable wrapper for consistent sizing.
// Pass src="/logo-cup-nosteam.png" for the steam-free variant (used on the
// post-a-brew confirmation).
export default function BrewCupIcon({ size = 16, className, src = '/logo-cup.png' }: Props) {
  return (
    <img
      src={src}
      alt=""
      aria-hidden="true"
      width={size}
      height={size}
      className={className}
      style={{ display: 'inline-block', objectFit: 'contain' }}
    />
  )
}
